import FetchInterceptor from "configs/FetchInterceptor";

class PurchasePastReturnsServices {
  static async getAll(requestBody) {
    const apiUrl = "/core/v1/purchase/invoice/past-return/get/all";
    const response = await FetchInterceptor.post(apiUrl, requestBody);
    return response;
  }
  static async getById(id) {
    const apiUrl = `/core/v1/purchase/invoice/past-return/get/${id}`;
    const response = await FetchInterceptor.get(apiUrl);
    return response;
  }
  static async add(requestBody) {
    const apiUrl = "/core/v1/purchase/invoice/past-return/add";
    const response = await FetchInterceptor.post(apiUrl, requestBody);
    return response;
  }
  static async update(requestBody) {
    const apiUrl = "/core/v1/purchase/invoice/past-return/update/status";
    const response = await FetchInterceptor.post(apiUrl, requestBody);
    return response;
  }
  static async getPdf(id) {
    const apiUrl = `/core/v1/purchase/invoice/past-return/get/pdf/${id}`;
    const response = await FetchInterceptor.get(apiUrl, {
      responseType: "blob",
    });
    return response;
  }
}

export default PurchasePastReturnsServices;
